import StripeSubscriptionsLayout from '../components/layouts/StripeSubscriptionsLayout.vue';
import StripeSubscriptionsIndexPage from '../pages/StripeSubscriptionsIndexPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/stripe-subscriptions',
        name: 'stripe-subscriptions.root',
        component: StripeSubscriptionsLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'stripeSubscriptions.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /stripe-subscriptions
                path: '',
                name: 'StripeSubscriptionsIndexPage',
                component: StripeSubscriptionsIndexPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /stripe-subscriptions/create
            //   name: 'stripe-subscriptions.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
